import { useQuery } from '@tanstack/react-query';
import { getDistinctValuesForFilter } from './getGLControlData';

export interface CountryOption {
  label: string;
  value: string;
}

export const fetchCountryNames = async (
  controlId: string,
  selectedRegions: string[]
): Promise<CountryOption[]> => {
  if (controlId !== 'grc18956') {
    return [];
  }
  const countries = await getDistinctValuesForFilter(
    controlId,
    'country_name',
    undefined,
    undefined,
    selectedRegions
  );
  return countries.map((country) => ({ label: country, value: country }));
};

export const useCountryName = (controlId: string, selectedRegions: string[] = []) => {
  return useQuery({
    queryKey: ['countries', controlId, selectedRegions],
    queryFn: () => fetchCountryNames(controlId, selectedRegions),
    enabled: Boolean(controlId && selectedRegions.length > 0),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
